<template>
    <div>
    	<van-nav-bar
		  	title="预约时段设定"
			left-arrow
		  	@click-left="$router.push('/')">
		</van-nav-bar>
		<van-field
			readonly
		   	
		    right-icon="arrow"
		    label="开店时间"
		    placeholder="选择开店时间"
		    @click="shopStartTime=true;"
		    />
		<van-popup v-model="shopStartTime" position="bottom">
			<van-datetime-picker
			  	type="time"
			  	:min-hour="0"
			  	:max-hour="23"
			  	@cancel="shopStartTime = false"
				@confirm=''
			/>
		</van-popup>
		<van-field 
			readonly
			
		    right-icon="arrow"
		    label="关店时间"
		    placeholder="选择关店时间"
		    @click="shopEndTime=true;"
		/>
		<van-popup v-model="shopEndTime" position="bottom">
			<van-datetime-picker
			  	type="time"
			  	:min-hour="0"
			  	:max-hour="23"
			  	@cancel="shopEndTime = false"
				@confim=''
			/>
		</van-popup>
		<van-field 
			readonly
		   	
		    right-icon="arrow"
		    label="午休开始时间"
		    placeholder="午休开始时间"
		    @click="restStartTime=true;"
		/>
		<van-popup v-model="restStartTime" position="bottom">
			<van-datetime-picker
			  	type="time"
			  	:min-hour="0"
			  	:max-hour="23"
			  	@cancel="restStartTime = false"
	
			/>
		</van-popup>
		<van-field 
			readonly
		   
		    right-icon="arrow"
		    label="午休结束时间"
		    placeholder="午休结束时间"
		    @click="restEndTime=true;"
		/>
		<van-popup v-model="restEndTime" position="bottom">
			<van-datetime-picker
			  	type="time"
			  	:min-hour="0"
			  	:max-hour="23"
			  	@cancel="restEndTime = false"
	
			/>
		</van-popup>
		<van-field 
			readonly
		   
		    right-icon="arrow"
		    label="时间分段"
		    placeholder="请选择时间分段"
		    @click="showTime=true;"
		/>
		<van-popup v-model="showTime" position="bottom">
			<van-picker
			    show-toolbar
			    :columns="times"
			    @cancel="showTime = false"
			    @confirm=''
  			/>
		</van-popup>
		<van-cell title='是否有空才能预约'> 
			<van-radio-group slot='right-icon' v-model='radio'>
				<van-radio name='1' class='status'>
			    是
			    <img
			    	width='20px'
			    	height='20px'
				    slot="icon"
				    slot-scope="props"
				    :src="props.checked ? './static/img/sele.png': './static/img/unsele.png'"
			    >
			  </van-radio>
			  <van-radio name='2' class='status'>
			    否
			    <img
			    	width='20px'
			    	height='20px'
			      	slot="icon"
			      	slot-scope="props"
			      	:src="props.checked ? './static/img/sele.png': './static/img/unsele.png'"
			    >
			  </van-radio>
			</van-radio-group>
		</van-cell>
		<van-field 
			readonly
		   	@click='restDay=true'
		    right-icon="arrow"
		    label="每周休息日"  
		/>
		<van-popup v-model='restDay' position='bottom'>
			<van-picker
				show-toolbar
				:columns='days'
				@cancel="restDay = false"
				@confrim=''
			/>
		</van-popup>
		<van-field 
			readonly
		   	
		    right-icon="arrow"
		    label="放假列表"  
		/>
    </div>
</template>
<script>
  	export default {
  		data(){
  			return{
  				radio:'1',
  				shopStartTime:false,
  				shopEndTime:false,
  				restStartTime:false,
  				restEndTime:false,
  				showTime:false,
  				times:["5","10","15","20","25","30"],
  				restDay:false,

  				days:['周一','周二','周三','周四','周五','周六','周日']
  			}
  		}

  	}   	
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-cell__title,/deep/ .van-field__control{
		font-size: 14px;
	}
	/deep/ .van-field__label{
		width: 150px;
	}
	.status{
		width: 50px;
        float: left;
	}
</style>


// WEBPACK FOOTER //
// src/Service/EditBookTime.vue